import { render, staticRenderFns } from "./sunbed.vue?vue&type=template&id=bf697070&"
import script from "./sunbed.vue?vue&type=script&lang=js&"
export * from "./sunbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports